"use client";
import React from "react";
import NewsTag from "./tag";
import Image from "next/image";
import { Sport } from "common";
import Card from "../primitives/card";
import Icon from "../primitives/icon";

interface ArticleProps {
  title: string;
  img: string;
  league: Sport;
  date: string;
  children: React.ReactNode;
}
export default function NewsArticle(props: ArticleProps) {
  const leagueIcons: { [key: string]: string } = {
    nba: "basketball",
    nfl: "football",
    nhl: "hockey-puck",
    mlb: "baseball",
  };

  const icon: any = leagueIcons[props.league];
  const date = new Date(props.date).toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  return (
    <>
      <Card className="!p-0 my-6">
        <Image
          src={props.img}
          alt={props.title}
          unoptimized
          width={744}
          height={425}
        />
        <div className="py-12 px-10 flex flex-col gap-8">{props.children}</div>
      </Card>
      <div className="flex flex-row justify-between items-center">
        <div className="flex flex-row items-center gap-2">
          <Icon variant="circle" name="monogram" size="sm" />
          <div className="flex flex-col gap-1">
            <div className="text-title-sm-medium">Moneyline</div>
            <div className="flex gap-2 text-label-lg-medium text-secondary-400">
              <span>Last Updated:</span>
              <span>{date}</span>
            </div>
          </div>
        </div>
        {/* <NewsShare /> */}
      </div>
      <hr className="bg-secondary-700 my-8"></hr>
      <div className="flex flex-row gap-2 flex-wrap">
        <NewsTag label={props.league} icon={icon}></NewsTag>
        {/* <NewsTag label="portland trail blazers"></NewsTag>
          <NewsTag label="damian lillard"></NewsTag> */}
      </div>
    </>
  );
}
